import { Component } from '@angular/core';
import { AdminEditableBaseComponent } from '../admin-editable-base.component';

@Component({
  selector: 'thema-core-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent extends AdminEditableBaseComponent {}
